import Popup from '@shared/components/Popup/Popup';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Building } from 'assets/icons/Building.svg';
import GradientIconWithShadow from 'components/GradientIconWithShadow/GradientIconWithShadow';
import ModalFooter from 'components/ModalFooter';
import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';

import useCreateWorkspaceDataContext from '../CreateWorkspaceDataProvider/useCreateWorkspaceDataContext';
import { CreateWorkspaceStepsEnum } from '../types';

const WorkspaceSuccessStep = () => {
  const { t } = useTranslation();
  const { matrixClient } = useMatrixContext();
  const { removeModal, setCurrentStep, wasInviteStepSkipped, createdWorkspaceId } = useCreateWorkspaceDataContext();

  const workspaceName = matrixClient.getRoom(createdWorkspaceId ?? undefined)?.name;

  const handleInviteMore = () => setCurrentStep(CreateWorkspaceStepsEnum.INVITE);

  return (
    <Popup isVisible wrapperId="create-workspace-modal">
      <Popup.FullScreenContainer className="md:w-120">
        <div className="flex flex-col grow overflow-y-auto p-4" data-testid="success-step-modal">
          <div className="flex flex-col items-center justify-center w-full py-6 text-center">
            <GradientIconWithShadow icon={Building} iconClassName="!stroke-1.5" />
            <h1 className="text-2xl font-medium mb-2 mt-8 text-size-lg">
              {t('workspaces.workspace_created', { name: workspaceName })}
            </h1>
            {!wasInviteStepSkipped && <p className="max-w-[517px]">{t('workspaces.workspace_created_subtitle')}</p>}
          </div>
        </div>
        <ModalFooter
          onCloseClick={handleInviteMore}
          onSubmit={removeModal}
          successButtonText={t('finish')}
          cancelText={t('workspaces.invite_more_people')}
          className="flex-wrap xs:flex-nowrap"
        />
      </Popup.FullScreenContainer>
    </Popup>
  );
};

export default WorkspaceSuccessStep;
